import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type { OcrTemplateFieldHistoryResponse } from '../types';

const { OCR_TEMPLATES } = API_ENDPOINTS;

export const fieldHistoryApi = {
  /**
   * The whole per-field extraction history for one template, in one response.
   * Unpaginated by design — the row count is the template's field count.
   */
  forTemplate: (templateId: number) =>
    apiClient.get<OcrTemplateFieldHistoryResponse>(
      OCR_TEMPLATES.FIELD_HISTORY(templateId)
    )
};
